/**
 * Cost Tracker Utility
 * Fire-and-forget function to log LLM token usage to the backend.
 * Never throws — cost tracking should never break the app.
 */

import { calculateCost } from '@/data/llmPricing';
import { API_BASE } from '@/config/api';
import { fetchWithCsrf } from './fetchWithCsrf';

interface TrackUsageParams {
  provider: string;
  model: string;
  feature: string;
  inputTokens: number;
  outputTokens: number;
  actualCost?: number;
}

/**
 * Log a single LLM call's token usage. Non-blocking, silent on failure.
 */
export function trackUsage(params: TrackUsageParams): void {
  const { provider, model, feature, inputTokens, outputTokens, actualCost } = params;
  const totalTokens = inputTokens + outputTokens;
  const estimatedCost = calculateCost(provider, model, inputTokens, outputTokens);

  fetchWithCsrf(`${API_BASE}/api/costs/log`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      provider,
      model,
      feature,
      inputTokens,
      outputTokens,
      totalTokens,
      estimatedCost,
      ...(actualCost !== undefined && { actualCost }),
    }),
  }).catch(() => {}); // Silent fail
}
